import React from "react";
import AttributionReport from "./AttributionReport";
import { Card, Row, Spin } from "antd";

const AttributionTab = ({
  campaign,
  chartData,
  chartsLoading,
  attributionLocations,
  byWalkinRangeDate,
  setByWalkinRangeDate,
  dataWalkinRangeDate,
  setDataWalkinRangeDate,
  byWalkinRangeDateHead,
  setByWalkinRangeDateHead,
  dataWalkinRangeDateHead,
  setDataWalkinRangeDateHead,
  amplify,
}) => {
  if (chartsLoading)
    return (
      <Card style={{ height: "300px" }}>
        <Row
          type="flex"
          justify="center"
          align="middle"
          style={{ height: "300px" }}
        >
          <Spin size="large" />
        </Row>
      </Card>
    );

  return (
    <AttributionReport
      campaign={campaign}
      chartData={chartData}
      attributionLocations={attributionLocations}
      byWalkinRangeDate={byWalkinRangeDate}
      setByWalkinRangeDate={setByWalkinRangeDate}
      dataWalkinRangeDate={dataWalkinRangeDate}
      setDataWalkinRangeDate={setDataWalkinRangeDate}
      byWalkinRangeDateHead={byWalkinRangeDateHead}
      setByWalkinRangeDateHead={setByWalkinRangeDateHead}
      dataWalkinRangeDateHead={dataWalkinRangeDateHead}
      setDataWalkinRangeDateHead={setDataWalkinRangeDateHead}
      amplify={amplify}
    />
  );
};

export default AttributionTab;
